<template>
  <div class="faq">
    <a
      :class="faqQuestionClasses"
      href="#"
      tabindex="0"
      @click.prevent="$emit('faq-selected', faq)"
    >
      {{ faq.Question }}
    </a>
    <transition name="fade">
      <div
        v-show="showAnswer"
        class="faq-answer"
      >
        <vue-markdown>{{ faq.Answer }}</vue-markdown>
      </div>
    </transition>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown'

export default {
  components: {
    VueMarkdown
  },
  props: {
    faq: { type: Object, default: null },
    selectedFaq: { type: Object, default: null }
  },
  computed: {
    showAnswer () {
      return this.selectedFaq !== null && this.selectedFaq.Id === this.faq.Id
    },
    faqQuestionClasses () {
      return {
        'faq-question': true,
        'faq-question--open': this.showAnswer
      }
    }
  }
}
</script>

<style lang="scss">
.faq {
  &-question {
    color: $grad-color-purple;
    font-family: $font-open-sans;
    font-weight: 800;
    font-size: 18px;
    margin-bottom: 20px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }

    &--open {
      color: #000;

      &:hover {
        text-decoration: none;
      }
    }
  }

  .fade {
    &-enter-active {
      transition: opacity 0.8s;
    }

    &-leave-active {
      opacity: 0;
    }

    &-enter,
    &-leave-to {
      opacity: 0;
    }
  }

  &-answer {
    ul {
      margin-bottom: 20px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/home/faq/components/Faq.vue